<template>
  <div>
  <div >
    <van-nav-bar>
      <template #left>
      <a-space >
        <span class="header-label">活動類別</span>
        <a-select
          v-model="selected"
          @change="ontype"
          class="header-select"
          :size="'large'"
          :dropdown-match-select-width="false"
          style="width: 30vw; min-width: 140px; max-width: 350px;"
        >
          <a-select-option value="all">全部</a-select-option>
          <a-select-option v-for="list in myJson" :key="list.value" :value="list.value">
            {{ list.title }}
          </a-select-option>
        </a-select>
      </a-space>
      </template>
      <template #right>
        <van-icon name="search" @click="searchAct()" size="24" class="header-action" />
        <van-icon name="user-o" @click="openProfile()" size="24" class="header-action" />
        <van-icon name="location-o" @click="openArie()" size="24" class="header-action" />
        <van-icon name="like-o" @click="openContent()" size="24" class="header-action danger" />
      </template>
    </van-nav-bar>

  </div>

      <b-modal ref="my-lines" size="sm" centered @hide="onHide" id="LineLg" title="Line 登入" hide-header hide-footer>
        <div class="text-center">
        <Linelogin />
        </div>
      </b-modal>  
      
      <a-modal
        :title="'我的最愛❤'"
        :visible="visible"
        :closable="true"   
        :maskClosable="false"
        :okText="'關閉'"
        :cancelText="''"
        :bodyStyle="{ padding:'15px'}"
        @ok="handelCancel"
        @cancel="handelCancel"
        class="simple-love-modal"
        :width="450"
      >
      <div class="text-center overflow-auto">
         <div style="padding:0rem;max-height: 550px;" v-if="user!==null" class="text-left">
          <b-list-group v-if="user.data.user.acts_loves && user.data.user.acts_loves.length > 0">
            <b-list-group-item 
              v-for="data in user.data.user.acts_loves" 
              :key="data.ids"
              class="d-flex justify-content-between align-items-center simple-love-item"
              :class="{ 'deleting': deletingLoves[data.id] }"
            >
              <div class="d-flex align-items-center" @click="query(data)" style="cursor: pointer; flex-grow: 1;">
                <b-avatar 
                  variant="primary" 
                  :src="data.pri_url" 
                  :size="40" 
                  class="align-baseline simple-avatar"
                ></b-avatar>
                <span v-text="data.name" style="padding-left: 0.8rem;font-size: medium; font-weight: 500;" />
              </div>
              <b-button
                variant="outline-danger"
                size="sm"
                class="simple-delete-btn"
                @click="confirmDeleteLove(data)"
                :disabled="deletingLoves[data.id]"
                title="移除最愛"
              >
                <b-spinner small v-if="deletingLoves[data.id]" class="loading-spinner"></b-spinner>
                <b-icon v-else icon="trash" font-scale="1.2"></b-icon>
              </b-button>
            </b-list-group-item>
          </b-list-group>
          <div v-else class="text-center p-4">
            <b-icon icon="heart" font-scale="3" variant="muted"></b-icon>
            <p class="text-muted mt-2">目前沒有最愛項目</p>
          </div>
         </div>
      </div>
      <template slot="footer">
          <div class="text-center">
            <small class="text-muted">點擊名稱查看活動 • 點擊垃圾桶移除最愛</small>
          </div>          
      </template>
      </a-modal>

      <a-modal
        :title= "'我的區域'"
        :visible="visible2"
        :closable=true   
        :maskClosable=false
        :okText="'刪除'"
        :okType="'danger'"
        :cancelText= "'取消'"
        :bodyStyle="{ padding:'10px'}"
        @cancel="handelCancel2"
      >
      <div class="text-center overflow-auto">
         <div style="padding:0rem;max-height: 550px;" v-if="user!==null" class="text-center">
          <a-row type="flex" justify="center" :align="'middle'" >
              <a-col :span="10" v-for="data in groupedData" :key="data.village">                
                <a-button shape="round"  @click="toArea(data.village)" style="margin:0.4rem;" :size="'large'" >
                  <b-icon icon="geo-alt-fill"  aria-hidden="true"></b-icon>
                  <span v-text="data.village" style="padding-left: 0.5rem;font-size: medium;" />
                </a-button>
              </a-col>                  
          </a-row>  
         </div>
      </div>
      <template slot="footer">
          <div class="text-center">
          </div>          
      </template>
      </a-modal>

      <van-popup 
        v-model="visible3" 
        position="center"
        :style="{ width: '90%', maxWidth: '500px', maxHeight: '80vh' }"
        round
        :close-on-click-overlay="false"
      >
        <div class="popup-header">
          <div class="popup-title">基本資料調整</div>
          <van-icon name="close" @click="handelCancel3" class="popup-close" />
        </div>
        <div class="popup-content text-center">
        <!-- 帳號更新訊息顯示區域 -->
        <div 
          v-if="usernameMessage.show" 
          class="username-message"
          :class="[
            'username-message--' + usernameMessage.type,
            { 'username-message--show': usernameMessage.show }
          ]"
        >
          <div class="username-message__content">
            <a-icon 
              :type="usernameMessage.type === 'success' ? 'check-circle' : 
                    usernameMessage.type === 'error' ? 'close-circle' : 
                    usernameMessage.type === 'warning' ? 'exclamation-circle' : 'info-circle'"
            />
            <span>{{ usernameMessage.text }}</span>
          </div>
        </div>
        <a-alert v-if="messages!==''" :message="messages" type="info" close-text="Close Now" />
        <a-spin :spinning="iconLoading">
        <div class="spin-content" v-if="user!==null">           
        <blockquote class="blockquote mb-0">
          <div style="text-align: center; margin-bottom: 1rem;">
            <b-avatar  variant="info" :src="user.data.user.pri_url" size="4rem" class="avatar" style="margin: 0.5rem;"></b-avatar>
            <div style="font-size: 16px;font-weight: bold; color: #666; margin-top: 0.5rem; display: flex; align-items: center; justify-content: center; gap: 8px;">
              <template v-if="!isEditingUsername">
                <span>帳號：{{ user.data.user.username }}</span>
                <a-button 
                  type="link" 
                  size="small" 
                  @click="startEditUsername"
                  style="padding: 0 8px; height: 24px;"
                >
                  <a-icon type="edit" style="color: #1890ff; font-size: 22px;" />
                </a-button>
              </template>
              <template v-else>
                <div style="display: flex; align-items: center; gap: 8px; flex-direction: column; width: 100%;">
                  <div style="display: flex; align-items: center; gap: 8px; width: 100%; max-width: 300px;">
                    <span style="white-space: nowrap;">帳號：</span>
                    <b-form-input
                      v-model="tempUsername"
                      type="tel"
                      placeholder="請輸入手機號碼"
                      autocomplete="off"
                      maxlength="10"
                      style="flex: 1;"
                      @input="onPhoneInput"
                      @keyup.enter="saveUsername"
                      @keyup.esc="cancelEditUsername"
                    ></b-form-input>
                  </div>
                  <div style="display: flex; gap: 8px;">
                    <a-button 
                      type="primary" 
                      size="large" 
                      @click="saveUsername"
                      :disabled="!canSaveUsername"
                      :loading="isCheckingPhone"
                      style="height: 28px; font-size: 12px;"
                    >
                      <a-icon v-if="!isCheckingPhone" type="check" /> 確定
                    </a-button>
                    <a-button 
                      size="large" 
                      @click="cancelEditUsername"
                      style="height: 28px; font-size: 12px;"
                    >
                      <a-icon type="close" /> 取消
                    </a-button>
                  </div>
                  <!-- 驗證提示訊息 -->
                  <div v-if="tempUsername" style="width: 100%; max-width: 300px;">
                    <div v-if="!isValidPhoneFormat(tempUsername)" style="color: #ff4d4f; font-size: 12px; margin-top: 4px; display: flex; align-items: center; gap: 4px;">
                      <a-icon type="close-circle" />
                      請輸入有效的手機號碼 (09開頭的10位數字)
                    </div>
                    <div v-else-if="isCheckingPhone" style="color: #1890ff; font-size: 12px; margin-top: 4px; display: flex; align-items: center; gap: 4px;">
                      <a-icon type="loading" spin />
                      正在檢查帳號...
                    </div>
                    <div v-else-if="phoneCheckResult === false" style="color: #ff4d4f; font-size: 12px; margin-top: 4px; display: flex; align-items: center; gap: 4px;">
                      <a-icon type="close-circle" />
                      此帳號已被使用，請更換其他號碼
                    </div>
                    <div v-else-if="phoneCheckResult === true" style="color: #52c41a; font-size: 12px; margin-top: 4px; display: flex; align-items: center; gap: 4px;">
                      <a-icon type="check-circle" />
                      此帳號可以使用
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>        
                      <b-form @submit="onSubmit">
                        <b-form-group id="input-group-3" description label-for="input-9">
                          <label class="d-flex align-items-left" for="input-9">
                            <span style="font-size: 15px;" v-text="'建立顯示名稱 ( 請填寫真實姓名 ) : '"></span>
                          </label>
                          <b-form-input
                            id="input-9"
                            v-model="form.displayname"
                            autocomplete="off"
                            placeholder="請填寫真實中文姓名"
                            required
                          ></b-form-input>
                        </b-form-group>
                        <div style="padding:1px;">
                          <Addresscom @toaddress="toaddress" />
                        </div>
                        <b-form-group id="input-group-2" description label-for="input-8">
                          <label class="d-flex align-items-left" for="input-8">
                            <code>*</code>
                            <span style="color:crimson;font-size: 15px;" v-text="'輸入地址 : ⚠街道路號可選填'"></span>
                          </label>
                          <div style="display: flex; justify-content: space-between;">
                          <b-form-input
                            id="input-8"
                            v-model="form.address"
                            autocomplete="off"
                            :disabled="true"
                            style="width:50%"
                            placeholder="選擇縣市鄉鎮"
                            required
                          ></b-form-input>
                          <b-form-input
                            id="input-8"
                            v-model="otherAddress"
                            autocomplete="off"
                            style="width:50%"
                            placeholder="輸入街道路號"
                          ></b-form-input>                     
                          </div> 
                        </b-form-group>
                        <b-form-group id="input-group-11" description label-for="input-sex">
                          <label class="d-flex align-items-left" for="input-sex">
                            <code>*</code>
                            <span style="color:crimson; font-size: 15px;">輸入性別 (男/女)</span>
                          </label>
                          <b-form-select
                            id="input-sex"
                            v-model="form.sex"
                            :options="[{ value: 'male', text: '男' }, { value: 'female', text: '女' }, { value: 'other', text: '其它' }]"
                            placeholder="請選擇性別"
                            required
                          ></b-form-select>
                        </b-form-group>
                        
                        <div style="margin-bottom: 0.5rem; border: 1px solid #bbb; border-radius: 8px; padding: 2px;">
                        <van-field
                          v-model="form.birth"
                          label="生日"
                          placeholder="請輸入生日"
                          required
                          is-link
                          readonly
                          @click="openPicker"
                        />
                        <van-popup v-model="showPicker" position="bottom">
                          <van-datetime-picker
                            type="date"
                            title="選擇生日"
                            :value="pickerValue"
                            :min-date="minDate"
                            :max-date="maxDate"
                            @confirm="onConfirm"
                            @cancel="showPicker = false"
                            confirm-button-text="確定"
                            cancel-button-text="取消"                            
                          />
                        </van-popup>                        
                        </div>                        
                        
                        <b-form-group id="input-group-13" description label-for="input-phone">
                          <label class="d-flex align-items-left" for="input-phone">
                            <code>*</code>
                            <span style="color:crimson; font-size: 15px;">輸入手機號碼</span>
                          </label>
                          <b-form-input
                            v-model="form.hphone"
                            type="number"   
                            placeholder="輸入手機 "   
                            autocomplete="off"
                            required
                          ></b-form-input>
                        </b-form-group>                          

                        <a-button-group>
                          <a-button
                            type="primary"
                            html-type="submit"
                            style="width: 220px; height: 50px; font-size: 16px;"
                            :disabled=" form.address==='' || form.sex==='' || form.birth==='' || form.displayname==='' || form.hphone===''"
                          >更新</a-button>
                        </a-button-group>
                      </b-form>
                    </blockquote>
                  </div>
                </a-spin>                    
        </div>
      </van-popup> 
      
<!-- 活動搜尋彈窗 -->
      <van-popup 
        v-model="visibleSearch" 
        position="center"
        :style="{ width: '90%', maxWidth: '500px' }"
        round
        :close-on-click-overlay="false"
      >
        <div class="popup-header">
          <div class="popup-title">活動搜尋</div>
          <van-icon name="close" @click="closeSearch" class="popup-close" />
        </div>
        <div class="search-popup-content">
          <div class="search-input-wrapper">
            <a-input-search
              v-model="searchKeyword"
              placeholder="請輸入活動名稱或關鍵字"
              size="large"
              @search="handleSearch"
              @pressEnter="handleSearch"
              :loading="searchLoading"
              allow-clear
              autofocus
            >
              <a-icon slot="prefix" type="search" style="color: rgba(0,0,0,.45)" />
            </a-input-search>
          </div>
          <div class="search-tips">
            <a-icon type="info-circle" style="color: #1890ff; margin-right: 4px;" />
            <span>輸入關鍵字後按 Enter 或點擊搜尋圖示</span>
          </div>
          <div class="search-actions">
            <a-button 
              type="primary" 
              size="large" 
              block
              @click="handleSearch"
              :loading="searchLoading"
              :disabled="!searchKeyword || searchKeyword.trim() === ''"
            >
              <a-icon type="search" />
              開始搜尋
            </a-button>
          </div>
        </div>
      </van-popup>      

  </div>
</template>

<script>
import Linelogin from "../../auth/Linelogin.vue";
import MY_JSON from '../../assets/json/optiondata.json'
import TW_JSON from '../../assets/json/twdata.json'
import Addresscom from "../../components/Addresslist.vue";
import { userService, loveService } from "../../_services/";
import { mapState, mapActions, mapMutations } from "vuex";
import { Field, Popup, DatetimePicker,NavBar, Icon, DropdownMenu, DropdownItem } from 'vant';

export default {
  name: "Linemenubar",
  components: {
    Linelogin,
    Addresscom,
    [Field.name]: Field,
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,
    [NavBar.name]: NavBar,
    [Icon.name]: Icon,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem
  },
  props: {
    msg: String,
  },
  data() {
    return {
      myJson: MY_JSON, 
      twJson: TW_JSON,
      visible:false, 
      visible2:false,  
      visible3:false,
      deletingLoves: {}, // 追踪哪些項目正在刪除中
      isEditingUsername: false, // 是否正在編輯帳號
      tempUsername: '', // 臨時儲存編輯中的帳號
      isCheckingPhone: false, // 是否正在檢查帳號
      phoneCheckResult: null, // 帳號檢查結果：null(未檢查), true(可用), false(已被使用)
      usernameMessage: { show: false, type: 'success', text: '' }, // 帳號更新訊息狀態
      groupedData:[],
      show: null,
      selected:null,
      iconLoading: false, 
      messages:"",
      otherAddress:"",        
      form: {
        displayname:"",
        account: "",
        address: "",
        birth:"",
        sex:"",
        hphone:"",
        citys:'', 
        villages:'', 
        towns:'',         
      },
      showPicker: false,
      minDate: new Date(1920, 0, 1),
      maxDate: new Date(),
      pickerValue: new Date(), // 預設今天 
      visibleSearch: false, // 搜尋彈窗顯示狀態
      searchKeyword: '', // 搜尋關鍵字
      searchLoading: false, // 搜尋載入狀態                 
    };
  },
  methods: {
    ...mapActions("account", ["checktoken", "logout"]),
    ...mapMutations("account", ["updateProfileByLine", "updateUserLoves", "updateProfileWithAccount"]),
    showline() {
      this.$refs["my-lines"].show();      
    },

    closeline() {
      this.$refs["my-lines"].hide();      
    },    
 
    onHide(evt) {
          if(evt.trigger === "backdrop"){
              evt.preventDefault();
          }
      },
    ontype(){
      this.$emit("ontype",this.selected)
    },
    openContent(){
      this.visible=true;
    },
    handelCancel(){
      this.visible=false
    },
    openArie(){
      this.visible2=true;
    },
    openProfile(){
      this.messages='';
      this.visible3=true;
    },    
    handelCancel2(){
      this.visible2=false
    },    
    handelCancel3(){
      this.visible3=false
    },
    searchAct(){
      this.searchKeyword = '';
      this.visibleSearch = true;
    },

    // 關閉搜尋彈窗
    closeSearch() {
      this.visibleSearch = false;
      this.searchKeyword = '';
      this.searchLoading = false;
    },
    
    // 執行搜尋
    async handleSearch() {
      if (!this.searchKeyword || this.searchKeyword.trim() === '') {
        this.$message.warning('請輸入搜尋關鍵字');
        return;
      }
      
      try {
        this.searchLoading = true;
        
        // 發送搜尋事件到父組件
        this.$emit('searchActivity', this.searchKeyword.trim());
        
        // 顯示搜尋成功提示
        this.$message.success(`正在搜尋「${this.searchKeyword.trim()}」相關活動`);
        
        // 關閉彈窗
        setTimeout(() => {
          this.closeSearch();
        }, 500);
        
      } catch (error) {
        console.error('搜尋錯誤:', error);
        this.$message.error('搜尋失敗，請稍後再試');
      } finally {
        this.searchLoading = false;
      }
    },    
    
    // 開始編輯帳號
    startEditUsername() {
      this.isEditingUsername = true;
      this.tempUsername = this.user.data.user.username || '';
      this.phoneCheckResult = null; // 重置檢查結果
    },
    
    // 取消編輯帳號
    cancelEditUsername() {
      this.isEditingUsername = false;
      this.tempUsername = '';
      this.phoneCheckResult = null;
      this.isCheckingPhone = false;
      this.usernameMessage.show = false; // 關閉訊息
    },
    
    // 顯示帳號更新訊息（在 popup 內顯示 3 秒後自動關閉）
    showUsernameMessage(type, text) {
      this.usernameMessage = { show: true, type, text };
      setTimeout(() => {
        this.usernameMessage.show = false;
      }, 3000);
    },
    
    // 僅驗證手機號碼格式（不調用 API）
    isValidPhoneFormat(phone) {
      if (!phone) return false;
      // 台灣手機號碼格式：09開頭，共10位數字
      const phoneRegex = /^09\d{8}$/;
      return phoneRegex.test(phone);
    },
    
    // 當輸入框內容改變時觸發
    async onPhoneInput() {
      // 重置檢查結果
      this.phoneCheckResult = null;
      
      // 如果格式不正確，不調用 API
      if (!this.isValidPhoneFormat(this.tempUsername)) {
        return;
      }
      
      // 如果號碼與當前帳號相同，不需要檢查
      if (this.tempUsername === this.user.data.user.username) {
        this.phoneCheckResult = true;
        return;
      }
      
      // 調用 API 檢查帳號
      await this.checkPhoneAvailability(this.tempUsername);
    },
    
    // 檢查手機號碼是否可用
    async checkPhoneAvailability(phone) {
      try {
        this.isCheckingPhone = true;
        
        // 調用 API 檢查帳號
        let results1 = await userService.checkAcct(phone).then(rs => {
          return rs.data.verify;
        });
        
        // results1 == false 代表帳號沒被使用過，可以使用
        // results1 == true 代表帳號已被使用
        this.phoneCheckResult = !results1; // 取反，因為 false 代表可用
        
      } catch (error) {
        console.error('檢查帳號失敗:', error);
        this.phoneCheckResult = null;
        this.showUsernameMessage('error', '檢查帳號時發生錯誤，請稍後再試');
      } finally {
        this.isCheckingPhone = false;
      }
    },
    
    // 儲存帳號
    async saveUsername() {
      if (!this.isValidPhoneFormat(this.tempUsername)) {
        this.showUsernameMessage('warning', '請輸入有效的手機號碼 (09開頭的10位數字)');
        return;
      }
      
      // 如果還在檢查中，等待檢查完成
      if (this.isCheckingPhone) {
        this.showUsernameMessage('warning', '正在檢查帳號，請稍候...');
        return;
      }
      
      // 如果帳號已被使用
      if (this.phoneCheckResult === false) {
        this.showUsernameMessage('error', '此帳號已被使用，請更換其他號碼');
        return;
      }
      
      // 如果號碼沒有改變，直接關閉編輯模式
      if (this.tempUsername === this.user.data.user.username) {
        this.showUsernameMessage('info', '帳號未變更');
        this.isEditingUsername = false;
        this.tempUsername = '';
        this.phoneCheckResult = null;
        return;
      }
      
      try {
        this.iconLoading = true;
        
        // 調用更新帳號的 API
        const response = await userService.updateUsername({ 
          username: this.tempUsername, 
          uid: this.user.data.user.id.toString(), 
          displayname: this.user.data.user.display_name 
        });
        
        // 檢查 API 回應
        if (response && (response.status === 200 || response.data.Code === 200)) {
          // 透過 Vuex mutation 更新本地 store 中的用戶資料
          const updatedUsername = (response.data.Data && response.data.Data.username)
            ? response.data.Data.username
            : this.tempUsername;
          this.updateProfileWithAccount({ username: updatedUsername });
          
          // 如果後端有返回更新後的資料，使用後端的資料
          if (response.data.Data && response.data.Data.displayname) {
            this.user.data.user.display_name = response.data.Data.displayname;
          }
          
          // 顯示成功訊息
          this.showUsernameMessage('success', '帳號更新成功！');
          
          // 關閉編輯模式
          this.isEditingUsername = false;
          this.tempUsername = '';
          this.phoneCheckResult = null;
          
        } else {
          // 處理非 200 的成功狀態
          throw new Error(response.data.Msg || '更新失敗');
        }
        
      } catch (error) {
        console.error('更新帳號失敗:', error);
        
        // 根據不同的錯誤狀態顯示不同的訊息
        let errorMessage = '更新帳號失敗，請稍後再試';
        
        if (error.response) {
          const status = error.response.status;
          const data = error.response.data;
          
          switch (status) {
            case 400:
              // 參數錯誤或用戶名已被使用
              errorMessage = data.Msg || '參數錯誤或該用戶名稱已被使用';
              if (data.Msg && data.Msg.includes('已被使用')) {
                // 重新設置檢查結果為帳號已被使用
                this.phoneCheckResult = false;
              }
              break;
            case 404:
              errorMessage = '用戶不存在，請重新登入';
              // 可能需要導向登入頁面
              setTimeout(() => {
                this.logout();
                this.$router.push('/login');
              }, 2000);
              break;
            case 500:
              errorMessage = '伺服器錯誤，請稍後再試';
              break;
            default:
              errorMessage = data.Msg || '更新失敗，請稍後再試';
          }
        } else if (error.message) {
          errorMessage = error.message;
        }
        
        // 顯示錯誤訊息
        this.showUsernameMessage('error', errorMessage);
        
      } finally {
        this.iconLoading = false;
      }
    },
    
    query(item){
      this.$emit("onByOrg",item)
      this.handelCancel()
    },
    toArea(val){
      this.$emit("getArea",process.env.VUE_APP_AREA+val)
      this.handelCancel2()
    },
    
    // 確認刪除最愛
    confirmDeleteLove(data) {
      this.$bvModal.msgBoxConfirm(
        [
          this.$createElement('div', { class: 'confirm-delete-content' }, [
            this.$createElement('div', { class: 'confirm-icon-wrapper' }, [
              this.$createElement('b-icon', {
                props: {
                  icon: 'heart-fill',
                  'font-scale': 2.5,
                  variant: 'danger'
                },
                class: 'confirm-heart-icon'
              })
            ]),
            this.$createElement('h5', { class: 'confirm-title' }, '移除最愛'),
            this.$createElement('p', { class: 'confirm-message' }, [
              '確定要從最愛中移除',
              this.$createElement('strong', { class: 'org-name' }, ` 「${data.name}」 `),
              '嗎？'
            ]),
            this.$createElement('small', { class: 'confirm-hint' }, '此操作無法復原')
          ])
        ],
        {
          title: '',
          size: 'md',
          buttonSize: 'md',
          okVariant: 'danger',
          okTitle: '確認移除',
          cancelTitle: '取消',
          cancelVariant: 'outline-secondary',
          footerClass: 'confirm-footer p-3',
          headerClass: 'd-none',
          bodyClass: 'confirm-body p-4',
          hideHeaderClose: true,
          centered: true,
          noCloseOnBackdrop: true,
          noCloseOnEsc: true,
          modalClass: 'confirm-delete-modal'
        }
      )
      .then(value => {
        if (value) {
          this.deleteLove(data);
        }
      })
      .catch(err => {
        console.error('確認對話框錯誤:', err);
      });
    },

    // 刪除最愛
    async deleteLove(data) {
      try {
        // 設置loading狀態
        this.$set(this.deletingLoves, data.id, true);
        
        // 呼叫API刪除
        const response = await loveService.deletelove(data.id);
        
        // 檢查成功狀態
        const isSuccess = (
          (response && response.code === 200) ||
          (response && response.Code === 200) ||
          (response && response.msg === "done")
        );
        
        if (isSuccess) {
          // 從 Vuex store 中移除該項目
          const updatedLoves = this.user.data.user.acts_loves.filter(love => love.id !== data.id);
          
          // 更新 Vuex store
          this.updateUserLoves(updatedLoves);
          
          // 顯示成功訊息
          this.$bvToast.toast(`已將「${data.name}」從最愛中移除 ❤`, {
            title: '移除成功 ✅',
            variant: 'success',
            solid: true,
            autoHideDelay: 3000,
            toaster: 'b-toaster-top-center'
          });
        } else {
          // 檢查是否返回了刪除的物件結構
          const hasDeletedObject = (
            response && 
            typeof response === 'object' &&
            (Object.prototype.hasOwnProperty.call(response, 'id') || 
             Object.prototype.hasOwnProperty.call(response, 'ID'))
          );
          
          if (hasDeletedObject) {
            // 從 Vuex store 中移除該項目
            const updatedLoves = this.user.data.user.acts_loves.filter(love => love.id !== data.id);
            
            // 更新 Vuex store
            this.updateUserLoves(updatedLoves);
            
            // 顯示成功訊息
            this.$bvToast.toast(`已將「${data.name}」從最愛中移除 ❤`, {
              title: '移除成功 ✅',
              variant: 'success',
              solid: true,
              autoHideDelay: 3000,
              toaster: 'b-toaster-top-center'
            });
          } else {
            throw new Error(`刪除失敗: ${response?.msg || '未知錯誤'}`);
          }
        }
      } catch (error) {
        console.error('刪除最愛API錯誤:', error);
        
        // 提供用戶選擇
        this.$bvModal.msgBoxConfirm(
          '伺服器回應異常，但刪除操作可能已完成。是否要從列表中移除此項目？',
          {
            title: '確認操作',
            size: 'md',
            buttonSize: 'sm',
            okVariant: 'warning',
            okTitle: '移除',
            cancelTitle: '保留',
            centered: true
          }
        )
        .then(shouldRemove => {
          if (shouldRemove) {
            // 從 Vuex store 中移除該項目
            const updatedLoves = this.user.data.user.acts_loves.filter(love => love.id !== data.id);
            this.updateUserLoves(updatedLoves);
            
            this.$bvToast.toast(`已從列表中移除「${data.name}」`, {
              title: '已移除',
              variant: 'info',
              solid: true,
              autoHideDelay: 3000,
              toaster: 'b-toaster-top-center'
            });
          }
        })
        .catch(err => {
          console.error('確認對話框錯誤:', err);
        });
      } finally {
        // 清除loading狀態
        this.$set(this.deletingLoves, data.id, false);
      }
    },
    toaddress(val,city,village,town) {
      this.form.address = val;
      this.form.citys=city
      this.form.villages = village
      this.form.towns = town 
    }, 
    async onSubmit(event) {
      event.preventDefault();
        this.iconLoading = true;
        var playload = {
          display: this.form.displayname!==""?this.form.displayname:this.displayname,
          address: this.form.address+this.otherAddress.toString().trim(),
          birth:this.form.birth,
          sex:this.form.sex,
          hphone: this.form.hphone,
          citys:this.form.citys,   
          villages:this.form.villages,
          towns:this.form.towns,   
        };
        this.updateProfileByLine(playload);
        this.user.data.user.display_name = this.form.displayname!==""?this.form.displayname:this.displayname;
        this.user.data.user.hphone = this.form.hphone;
        this.user.data.user.address = this.form.address+this.otherAddress.toString().trim();
        this.user.data.user.birth=this.form.birth;
        this.user.data.user.sex=this.form.sex;
        this.user.data.user.citys =this.form.citys;
        this.user.data.user.villages = this.form.villages;
        this.user.data.user.towns =this.form.towns;   
        await userService
          .upprofile(this.user.data.user)
          .then(rs => {
            if(rs.status === 201) { 
              this.messages='更新成功';          
            }else {
              this.messages='更新失敗';   
            }                         
            setTimeout(() => {
              this.messages='';
              this.iconLoading = false; 
              this.visible3=false;
            }, 1200);            
           
          });
    }, 
    
    onConfirm(value) {
        this.form.birth = `${value.getFullYear()}-${(value.getMonth()+1).toString().padStart(2,'0')}-${value.getDate().toString().padStart(2,'0')}`;
        this.showPicker = false;
      },
    openPicker() {
      // 若 form.birth 有值，轉成 Date，否則用今天
      this.pickerValue = this.form.birth
        ? new Date(this.form.birth)
        : new Date();
      this.showPicker = true;
    }, 
  },
  mounted() {    
    if (this.user!==null) {
      this.form.hphone = this.user.data.user.hphone;
      this.form.displayname = this.user.data.user.display_name;
      this.form.address = this.user.data.user.address;
      this.form.birth=this.user.data.user.birth;
      this.form.sex=this.user.data.user.sex;
      this.form.citys = this.user.data.user.citys;
      this.form.villages = this.user.data.user.villages;
      this.form.towns = this.user.data.user.towns;
    }
  },  
  async created() {
    const filteredData = this.twJson.filter(item => item.city === process.env.VUE_APP_AREA);
    const uniqueVillages = [...new Set(filteredData.map(item => item.village))];
    this.groupedData = uniqueVillages.map(village => ({ village }));
  },

  computed: {
    ...mapState("account", ["status", "user"]),
    
    // 判斷是否可以儲存帳號
    canSaveUsername() {
      // 格式必須正確
      if (!this.isValidPhoneFormat(this.tempUsername)) {
        return false;
      }
      
      // 不能正在檢查中
      if (this.isCheckingPhone) {
        return false;
      }
      
      // 如果與當前帳號相同，可以儲存（雖然沒有改變）
      if (this.tempUsername === this.user.data.user.username) {
        return true;
      }
      
      // 必須通過可用性檢查
      return this.phoneCheckResult === true;
    },
  },
};
</script>
<style scoped>

.header-label {
  color: #2a2b2b;
  font-size: 0.9rem;
  font-weight: 500;
  white-space: nowrap;
}
.header-actions {
  display: flex;
  gap: 0.5rem;
  margin-right: 0.25rem;
}
.ant-btn {
  box-shadow: none;
}
::v-deep .van-field__control {
  font-size: 18px; /* 你想要的字體大小 */
}
.header-action {
  margin-left: 10px;
}
.danger {
  color: #ee0a24;
}

.popup-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border-bottom: 1px solid #ebedf0;
  background-color: #fff;
}

.popup-title {
  font-size: 16px;
  font-weight: 500;
  color: #323233;
}

.popup-close {
  font-size: 18px;
  color: #969799;
  cursor: pointer;
}

.popup-content {
  padding: 10px;
  max-height: calc(80vh - 60px);
  overflow-y: auto;
  overflow-x: hidden;
}

/* 簡化版我的最愛模態框樣式 */
.simple-love-modal ::v-deep .ant-modal-header {
  background: linear-gradient(135deg, #ff6b6b, #ffa8a8);
  border-bottom: none;
  border-radius: 8px 8px 0 0;
}

.simple-love-modal ::v-deep .ant-modal-title {
  color: white;
  font-weight: 600;
  font-size: 18px;
}

.simple-love-modal ::v-deep .ant-modal-close {
  color: white;
}

.simple-love-modal ::v-deep .ant-modal-close:hover {
  color: #f0f0f0;
}

.simple-love-modal ::v-deep .ant-modal-content {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.simple-love-item {
  border: 1px solid #f0f0f0 !important;
  border-radius: 8px !important;
  margin-bottom: 8px !important;
  transition: all 0.3s ease;
  background: white;
}

.simple-love-item:hover {
  transform: translateY(-1px);
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.1);
  border-color: #ff6b6b !important;
}

.simple-love-item.deleting {
  opacity: 0.6;
  transform: scale(0.98);
}

.simple-avatar {
  border: 2px solid white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.simple-delete-btn {
  border-radius: 6px;
  border: 2px solid #ff6b6b;
  color: #ff6b6b;
  background: transparent;
  padding: 6px 10px;
  transition: all 0.2s ease;
}

.simple-delete-btn:hover {
  background: #ff6b6b;
  color: white;
  transform: scale(1.05);
}

.simple-delete-btn:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 107, 107, 0.25);
}

.simple-love-modal ::v-deep .ant-modal-footer {
  background: #f8f9fa;
  border-top: 1px solid #e9ecef;
  text-align: center;
}

.loading-spinner {
  color: #ff6b6b;
}

/* 確認刪除對話框美化 */
::v-deep .confirm-delete-modal .modal-content {
  border-radius: 20px;
  border: none;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}

::v-deep .confirm-delete-modal .modal-dialog {
  max-width: 400px;
}

.confirm-delete-content {
  text-align: center;
  padding: 20px 10px;
}

.confirm-icon-wrapper {
  margin-bottom: 20px;
  position: relative;
}

.confirm-heart-icon {
  animation: heartPulse 1.5s ease-in-out infinite;
  filter: drop-shadow(0 4px 8px rgba(220, 53, 69, 0.3));
}

@keyframes heartPulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

.confirm-title {
  color: #2c3e50;
  font-weight: 600;
  margin-bottom: 15px;
  font-size: 1.4rem;
}

.confirm-message {
  color: #5a6c7d;
  font-size: 1rem;
  line-height: 1.5;
  margin-bottom: 10px;
}

.org-name {
  color: #dc3545;
  font-weight: 600;
  background: linear-gradient(135deg, #ff6b6b, #ffa8a8);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.confirm-hint {
  color: #adb5bd;
  font-style: italic;
  margin: 0;
}

::v-deep .confirm-delete-modal .confirm-body {
  background: linear-gradient(135deg, #ffffff, #f8f9fa);
}

::v-deep .confirm-delete-modal .confirm-footer {
  background: #f8f9fa;
  border-top: 1px solid #e9ecef;
  display: flex;
  justify-content: center;
  gap: 15px;
}

::v-deep .confirm-delete-modal .btn {
  border-radius: 25px;
  font-weight: 600;
  padding: 10px 25px;
  transition: all 0.3s ease;
  min-width: 100px;
}

::v-deep .confirm-delete-modal .btn-danger {
  background: linear-gradient(135deg, #dc3545, #c82333);
  border: none;
  box-shadow: 0 4px 15px rgba(220, 53, 69, 0.3);
}

::v-deep .confirm-delete-modal .btn-danger:hover {
  background: linear-gradient(135deg, #c82333, #bd2130);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(220, 53, 69, 0.4);
}

::v-deep .confirm-delete-modal .btn-outline-secondary {
  border: 2px solid #6c757d;
  color: #6c757d;
  background: transparent;
}

::v-deep .confirm-delete-modal .btn-outline-secondary:hover {
  background: #6c757d;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(108, 117, 125, 0.3);
}

/* 帳號更新訊息樣式 */
.username-message {
  position: relative;
  margin-bottom: 16px;
  opacity: 0;
  transform: translateY(-10px);
  transition: all 0.3s ease;
  pointer-events: none;
}

.username-message--show {
  opacity: 1;
  transform: translateY(0);
  pointer-events: auto;
}

.username-message__content {
  padding: 12px 16px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  text-align: center;
}

.username-message--success .username-message__content {
  background: rgba(82, 196, 26, 0.95);
  color: white;
  border: 1px solid rgba(82, 196, 26, 0.3);
}

.username-message--error .username-message__content {
  background: rgba(255, 77, 79, 0.95);
  color: white;
  border: 1px solid rgba(255, 77, 79, 0.3);
}

.username-message--warning .username-message__content {
  background: rgba(250, 173, 20, 0.95);
  color: white;
  border: 1px solid rgba(250, 173, 20, 0.3);
}

.username-message--info .username-message__content {
  background: rgba(24, 144, 255, 0.95);
  color: white;
  border: 1px solid rgba(24, 144, 255, 0.3);
}
</style>
<style>
#LineLg > .modal-dialog > .modal-content > .modal-body {
  border-color: transparent;
  background-color: transparent !important;
  color: white;
} 
#LineLg > .modal-dialog > .modal-content {
  border-color: transparent;  
  background-color: transparent !important;
}
.modal-backdrop{ 
  background-color: #f3f0f0 !important;
  opacity: 0.95 !important; /* 0.95 越大越黑，可自行調整 */
}
/* 搜尋彈窗樣式 */
.search-popup-content {
  padding: 20px;
}

.search-input-wrapper {
  margin-bottom: 16px;
}

.search-tips {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  background: #f0f5ff;
  border-radius: 8px;
  font-size: 13px;
  color: #666;
  margin-bottom: 16px;
}

.search-actions {
  margin-top: 16px;
}

/* Input Search 樣式調整 */
::v-deep .ant-input-search-button {
  height: 40px;
}

::v-deep .ant-input-affix-wrapper {
  border-radius: 8px;
}
</style>